import { InvalidUrlError } from '@execonline-inc/url';
import { AppyError } from '../Appy';
import { GroupResource } from '../GroupsStore/Types';
import { MissingLinkError } from '../LinkyLinky';
import { FormOutValues, FormTemplate, HasFormTemplates } from '../Resource/FormTemplates/Types';
import { Resource } from '../Resource/Types';
import { Error, ServerError } from '../ErrorHandling';

export type GroupError = AppyError | InvalidUrlError | MissingLinkError | Error | ServerError;

export interface GroupNewPayload {}

export type GroupNewResource = Resource<GroupNewPayload> & HasFormTemplates;

export interface NewingArgs {
  resource: GroupNewResource;
  template: FormTemplate;
}

export type UserGroupNewResource = Resource<Newing> & HasFormTemplates;

export interface Waiting {
  kind: 'waiting';
}

export interface Creating {
  kind: 'creating';
  groupNewResource: GroupNewResource;
  template: FormTemplate;
  values: FormOutValues;
}

export interface Success {
  kind: 'success';
  groupResource: GroupResource;
}

export interface AddParticipants {
  kind: 'add-participants';
  groupResource: GroupResource;
}

export interface Loading {
  kind: 'loading';
}

export interface Newing {
  kind: 'newing';
  groupNewResource: GroupNewResource;
  template: FormTemplate;
}

export interface LoadError {
  kind: 'load-error';
  error: GroupError;
}

export interface FormSubmissionError {
  kind: 'form-submission-error';
  groupNewResource: GroupNewResource;
  template: FormTemplate;
  error: GroupError;
}

export const waiting = (): Waiting => ({
  kind: 'waiting',
});

export const creating = (state: Newing, values: FormOutValues): Creating => {
  const { kind, ...previous } = state;
  return { kind: 'creating', ...previous, values };
};

export const success = (groupResource: GroupResource): Success => ({
  kind: 'success',
  groupResource,
});

export const addParticipants = (state: Success): AddParticipants => {
  const { kind, ...previous } = state;
  return { kind: 'add-participants', ...previous };
};

export const loading = (): Loading => ({
  kind: 'loading',
});

export const newing = (newingArgs: NewingArgs): Newing => {
  return {
    kind: 'newing',
    groupNewResource: newingArgs.resource,
    template: newingArgs.template,
  };
};

export const formSubmissionError = (
  groupNewResource: GroupNewResource,
  error: GroupError,
  template: FormTemplate,
): FormSubmissionError => {
  return {
    kind: 'form-submission-error',
    groupNewResource: groupNewResource,
    template: template,
    error,
  };
};

export const loadError = (error: GroupError): LoadError => ({ kind: 'load-error', error });

export type State =
  | Waiting
  | Loading
  | Newing
  | LoadError
  | FormSubmissionError
  | Creating
  | AddParticipants
  | Success;
